// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sidebar Container - Overlay on top */
.sidebar {
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  width: 320px;
  background: var(--sidebar-background, #f8f9fa);
  border-right: 1px solid var(--sidebar-border, #e9ecef);
  z-index: 1000;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
}

.sidebar.collapsed {
  width: 60px;
  transform: translateX(-100%);
}

/* Dark theme support */
[data-theme='dark'] .sidebar {
  background: var(--sidebar-background, #2d3748);
  border-right-color: var(--sidebar-border, #4a5568);
}

/* Sidebar Toggle Button - Always visible */
.sidebar-toggle {
  position: fixed;
  top: 20px;
  left: 20px;
  background: var(--button-background, #007bff);
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  z-index: 1002;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}


.sidebar-toggle:hover {
  background: var(--button-hover, #0056b3);
  transform: scale(1.05);
}

[data-theme='dark'] .sidebar-toggle {
  background: var(--button-background, #4a90e2);
}

[data-theme='dark'] .sidebar-toggle:hover {
  background: var(--button-hover, #357abd);
}

.chevron {
  color: white;
  font-size: 12px;
  transition: transform 0.3s ease;
}

.chevron.rotated {
  transform: rotate(180deg);
}

/* Sidebar Content */
.sidebar-content {
  padding: 60px 20px 20px 20px;
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* Sidebar Sections */
.sidebar-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.section-icon {
  color: var(--accent-color, #007bff);
  font-size: 16px;
}

.section-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: var(--text-color, #333);
}

[data-theme='dark'] .section-header h3 {
  color: var(--text-color, #e2e8f0);
}

/* Prompts List */
.prompts-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.prompt-item {
  background: var(--card-background, #ffffff);
  border: 1px solid var(--card-border, #e9ecef);
  border-radius: 8px;
  padding: 12px;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.prompt-item:hover {
  background: var(--card-hover, #f8f9fa);
  border-color: var(--accent-color, #007bff);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.15);
}

[data-theme='dark'] .prompt-item {
  background: var(--card-background, #4a5568);
  border-color: var(--card-border, #718096);
}

[data-theme='dark'] .prompt-item:hover {
  background: var(--card-hover, #2d3748);
  border-color: var(--accent-color, #4a90e2);
}

.prompt-text {
  font-size: 14px;
  color: var(--text-color, #333);
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

[data-theme='dark'] .prompt-text {
  color: var(--text-color, #e2e8f0);
}

/* History List */
.history-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 300px;
  overflow-y: auto;
}

.history-item {
  background: var(--card-background, #ffffff);
  border: 1px solid var(--card-border, #e9ecef);
  border-radius: 8px;
  padding: 12px;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.history-item:hover {
  background: var(--card-hover, #f8f9fa);
  border-color: var(--accent-color, #007bff);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.15);
}

[data-theme='dark'] .history-item {
  background: var(--card-background, #4a5568);
  border-color: var(--card-border, #718096);
}

[data-theme='dark'] .history-item:hover {
  background: var(--card-hover, #2d3748);
  border-color: var(--accent-color, #4a90e2);
}

.question-text {
  font-size: 14px;
  color: var(--text-color, #333);
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

[data-theme='dark'] .question-text {
  color: var(--text-color, #e2e8f0);
}

.question-time {
  font-size: 12px;
  color: var(--muted-color, #6c757d);
  font-style: italic;
}

[data-theme='dark'] .question-time {
  color: var(--muted-color, #a0aec0);
}

/* Loading State */
.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
}

.loading-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid var(--muted-color, #6c757d);
  border-top: 3px solid var(--accent-color, #007bff);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-state p {
  margin: 0;
  color: var(--muted-color, #6c757d);
  font-size: 14px;
}

[data-theme='dark'] .loading-state p {
  color: var(--muted-color, #a0aec0);
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 20px;
  color: var(--muted-color, #6c757d);
}

.empty-state p {
  margin: 0 0 4px 0;
  font-size: 14px;
}

.empty-state small {
  font-size: 12px;
}

[data-theme='dark'] .empty-state {
  color: var(--muted-color, #a0aec0);
}

/* Download Section */
.download-section {
  margin-top: auto;
  padding-top: 20px;
  border-top: 1px solid var(--divider-color, #e9ecef);
}

[data-theme='dark'] .download-section {
  border-top-color: var(--divider-color, #4a5568);
}

.download-button {
  width: 100%;
  background: var(--success-color, #28a745);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.download-button:hover {
  background: var(--success-hover, #218838);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
}

.download-icon {
  font-size: 16px;
}

/* Scrollbar Styling */
.sidebar-content::-webkit-scrollbar {
  width: 6px;
}

.sidebar-content::-webkit-scrollbar-track {
  background: transparent;
}

.sidebar-content::-webkit-scrollbar-thumb {
  background: var(--scrollbar-color, #cbd5e0);
  border-radius: 3px;
}

.sidebar-content::-webkit-scrollbar-thumb:hover {
  background: var(--scrollbar-hover, #a0aec0);
}

[data-theme='dark'] .sidebar-content::-webkit-scrollbar-thumb {
  background: var(--scrollbar-color, #4a5568);
}

[data-theme='dark'] .sidebar-content::-webkit-scrollbar-thumb:hover {
  background: var(--scrollbar-hover, #718096);
}

/* Responsive Design */
@media (max-width: 768px) {
  .sidebar {
    width: 280px;
  }
  
  .sidebar.collapsed {
    width: 50px;
  }
  
  .sidebar-content {
    padding: 50px 15px 15px 15px;
  }
}

@media (max-width: 480px) {
  .sidebar {
    width: 100vw;
    transform: translateX(-100%);
  }
  
  .sidebar.show {
    transform: translateX(0);
  }
  
  .sidebar.collapsed {
    width: 50px;
    transform: translateX(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Sidebar.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;EACE,eAAe;EACf,OAAO;EACP,MAAM;EACN,aAAa;EACb,YAAY;EACZ,8CAA8C;EAC9C,sDAAsD;EACtD,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,4BAA4B;AAC9B;;AAEA,uBAAuB;AACvB;EACE,8CAA8C;EAC9C,kDAAkD;AACpD;;AAEA,2CAA2C;AAC3C;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,6CAA6C;EAC7C,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,wCAAwC;AAC1C;;;AAGA;EACE,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,4BAA4B;EAC5B,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,2CAA2C;EAC3C,6CAA6C;EAC7C,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,sCAAsC;EACtC,0CAA0C;EAC1C,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,2CAA2C;EAC3C,yCAAyC;AAC3C;;AAEA;EACE,sCAAsC;EACtC,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,6CAA6C;EAC7C,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,sCAAsC;EACtC,0CAA0C;EAC1C,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,2CAA2C;EAC3C,yCAAyC;AAC3C;;AAEA;EACE,sCAAsC;EACtC,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6CAA6C;EAC7C,kDAAkD;EAClD,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mDAAmD;AACrD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,yCAAyC;EACzC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,YAAY;IACZ,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,wBAAwB;EAC1B;AACF","sourcesContent":["/* Sidebar Container - Overlay on top */\n.sidebar {\n  position: fixed;\n  left: 0;\n  top: 0;\n  height: 100vh;\n  width: 320px;\n  background: var(--sidebar-background, #f8f9fa);\n  border-right: 1px solid var(--sidebar-border, #e9ecef);\n  z-index: 1000;\n  transition: all 0.3s ease;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);\n}\n\n.sidebar.collapsed {\n  width: 60px;\n  transform: translateX(-100%);\n}\n\n/* Dark theme support */\n[data-theme='dark'] .sidebar {\n  background: var(--sidebar-background, #2d3748);\n  border-right-color: var(--sidebar-border, #4a5568);\n}\n\n/* Sidebar Toggle Button - Always visible */\n.sidebar-toggle {\n  position: fixed;\n  top: 20px;\n  left: 20px;\n  background: var(--button-background, #007bff);\n  border: none;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  z-index: 1002;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n\n.sidebar-toggle:hover {\n  background: var(--button-hover, #0056b3);\n  transform: scale(1.05);\n}\n\n[data-theme='dark'] .sidebar-toggle {\n  background: var(--button-background, #4a90e2);\n}\n\n[data-theme='dark'] .sidebar-toggle:hover {\n  background: var(--button-hover, #357abd);\n}\n\n.chevron {\n  color: white;\n  font-size: 12px;\n  transition: transform 0.3s ease;\n}\n\n.chevron.rotated {\n  transform: rotate(180deg);\n}\n\n/* Sidebar Content */\n.sidebar-content {\n  padding: 60px 20px 20px 20px;\n  height: 100%;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n/* Sidebar Sections */\n.sidebar-section {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.section-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.section-icon {\n  color: var(--accent-color, #007bff);\n  font-size: 16px;\n}\n\n.section-header h3 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--text-color, #333);\n}\n\n[data-theme='dark'] .section-header h3 {\n  color: var(--text-color, #e2e8f0);\n}\n\n/* Prompts List */\n.prompts-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.prompt-item {\n  background: var(--card-background, #ffffff);\n  border: 1px solid var(--card-border, #e9ecef);\n  border-radius: 8px;\n  padding: 12px;\n  text-align: left;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.prompt-item:hover {\n  background: var(--card-hover, #f8f9fa);\n  border-color: var(--accent-color, #007bff);\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.15);\n}\n\n[data-theme='dark'] .prompt-item {\n  background: var(--card-background, #4a5568);\n  border-color: var(--card-border, #718096);\n}\n\n[data-theme='dark'] .prompt-item:hover {\n  background: var(--card-hover, #2d3748);\n  border-color: var(--accent-color, #4a90e2);\n}\n\n.prompt-text {\n  font-size: 14px;\n  color: var(--text-color, #333);\n  line-height: 1.4;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n[data-theme='dark'] .prompt-text {\n  color: var(--text-color, #e2e8f0);\n}\n\n/* History List */\n.history-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.history-item {\n  background: var(--card-background, #ffffff);\n  border: 1px solid var(--card-border, #e9ecef);\n  border-radius: 8px;\n  padding: 12px;\n  text-align: left;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.history-item:hover {\n  background: var(--card-hover, #f8f9fa);\n  border-color: var(--accent-color, #007bff);\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.15);\n}\n\n[data-theme='dark'] .history-item {\n  background: var(--card-background, #4a5568);\n  border-color: var(--card-border, #718096);\n}\n\n[data-theme='dark'] .history-item:hover {\n  background: var(--card-hover, #2d3748);\n  border-color: var(--accent-color, #4a90e2);\n}\n\n.question-text {\n  font-size: 14px;\n  color: var(--text-color, #333);\n  line-height: 1.4;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n[data-theme='dark'] .question-text {\n  color: var(--text-color, #e2e8f0);\n}\n\n.question-time {\n  font-size: 12px;\n  color: var(--muted-color, #6c757d);\n  font-style: italic;\n}\n\n[data-theme='dark'] .question-time {\n  color: var(--muted-color, #a0aec0);\n}\n\n/* Loading State */\n.loading-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 20px;\n  text-align: center;\n}\n\n.loading-spinner {\n  width: 32px;\n  height: 32px;\n  border: 3px solid var(--muted-color, #6c757d);\n  border-top: 3px solid var(--accent-color, #007bff);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 16px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.loading-state p {\n  margin: 0;\n  color: var(--muted-color, #6c757d);\n  font-size: 14px;\n}\n\n[data-theme='dark'] .loading-state p {\n  color: var(--muted-color, #a0aec0);\n}\n\n/* Empty State */\n.empty-state {\n  text-align: center;\n  padding: 20px;\n  color: var(--muted-color, #6c757d);\n}\n\n.empty-state p {\n  margin: 0 0 4px 0;\n  font-size: 14px;\n}\n\n.empty-state small {\n  font-size: 12px;\n}\n\n[data-theme='dark'] .empty-state {\n  color: var(--muted-color, #a0aec0);\n}\n\n/* Download Section */\n.download-section {\n  margin-top: auto;\n  padding-top: 20px;\n  border-top: 1px solid var(--divider-color, #e9ecef);\n}\n\n[data-theme='dark'] .download-section {\n  border-top-color: var(--divider-color, #4a5568);\n}\n\n.download-button {\n  width: 100%;\n  background: var(--success-color, #28a745);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 12px 16px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.download-button:hover {\n  background: var(--success-hover, #218838);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);\n}\n\n.download-icon {\n  font-size: 16px;\n}\n\n/* Scrollbar Styling */\n.sidebar-content::-webkit-scrollbar {\n  width: 6px;\n}\n\n.sidebar-content::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.sidebar-content::-webkit-scrollbar-thumb {\n  background: var(--scrollbar-color, #cbd5e0);\n  border-radius: 3px;\n}\n\n.sidebar-content::-webkit-scrollbar-thumb:hover {\n  background: var(--scrollbar-hover, #a0aec0);\n}\n\n[data-theme='dark'] .sidebar-content::-webkit-scrollbar-thumb {\n  background: var(--scrollbar-color, #4a5568);\n}\n\n[data-theme='dark'] .sidebar-content::-webkit-scrollbar-thumb:hover {\n  background: var(--scrollbar-hover, #718096);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .sidebar {\n    width: 280px;\n  }\n  \n  .sidebar.collapsed {\n    width: 50px;\n  }\n  \n  .sidebar-content {\n    padding: 50px 15px 15px 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  .sidebar {\n    width: 100vw;\n    transform: translateX(-100%);\n  }\n  \n  .sidebar.show {\n    transform: translateX(0);\n  }\n  \n  .sidebar.collapsed {\n    width: 50px;\n    transform: translateX(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
